import styled from 'styled-components';

import { Toast } from '@zillow/constellation';

export const StyledToast = styled(Toast)`
    max-width: unset;
`;
